import { render, staticRenderFns } from "./OrderDetailMails.vue?vue&type=template&id=0428627d&scoped=true&"
import script from "./OrderDetailMails.vue?vue&type=script&lang=js&"
export * from "./OrderDetailMails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0428627d",
  null
  
)

export default component.exports